import React, { useCallback } from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Theme } from '@mui/material/styles';
import { SelectChangeEvent, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import BusinessIcon from '@mui/icons-material/Business';
import { useOrganizationList } from '../../data/DataProviders/OrganizationListProvider';
import { removeLocationId } from '../../routes';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { useHistory } from 'react-router-dom';
import { SELECTED_ORGANIZATION } from '../../constants';

type Organization = { id: string; name: string };
type organizationList = {
    organizationList: Organization[];
    selectedOrganization: string;
    updateSelectedOrganization: (organizationID: string) => void;
};
const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
            '& .MuiTouchRipple-root': {
                borderLeft: `7px solid  ${theme.palette.primary.main}`,
            },
        },
    },
}))(MenuItem);
export const OrganizationDropdownToolbar: React.FC<{ TestOrgList?: organizationList }> = (props) => {
    const MENU_ITEM_HEIGHT = 48;
    const DRAWER_WIDTH = 360;
    const currentAppRoute = useCurrentAppRoute();
    const history = useHistory();
    let organizationList: organizationList;
    const useOrganizationDataList = useOrganizationList();
    const [selectedOrganization, setSelectedOrganization] = React.useState<string>('');
    const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            formControl: {
                color: PXBColors.white[400],
                margin: theme.spacing(1),
                marginLeft: 32,
                width: 270,
                background: 'none',
            },
            dropdown: {
                color: PXBColors.white[400],
            },
            subheaderClass: {
                color: PXBColors.white[400],
                display: 'flex',
                alignItems: 'center',
                marginLeft: '20px',
            },
            PaperStyle: {
                left: '0px !important',
                borderRadius: 0,
            },
            icon: {
                color: PXBColors.white[400],
            },
            select: {
                '&:focus': { background: 'none',
            },
            },
        })
    );
    const classes = useStyles();
    if (props.TestOrgList) {
        organizationList = props.TestOrgList;
    } else {
        organizationList = useOrganizationDataList;
    }
    if (selectedOrganization === '' && organizationList.selectedOrganization) {
        window.localStorage.setItem(SELECTED_ORGANIZATION, organizationList.selectedOrganization);
        setSelectedOrganization(organizationList.selectedOrganization);
    }
    const onDropdownCloseHandler = useCallback((): void => {
        setIsDropdownOpen(false);
    }, []);

    const onDropdownOpenHandler = useCallback((): void => {
        setIsDropdownOpen(true);
    }, []);
    const setCurrentLocation = (newLocationId: string | undefined, orgId: string): void => {
        if (!newLocationId) {
            pushAppRoute(history, removeLocationId(currentAppRoute, orgId));
            return;
        }
    };
    const onSelectedOrganizationChangeHandler = (event: SelectChangeEvent): void => {
        setSelectedOrganization(event.target.value);
        if (event.target.value !== '0') {
            organizationList.updateSelectedOrganization(event.target.value);
            setCurrentLocation(undefined, event.target.value);
        }
    };

    return (
        <div
            data-testid="organization-dd-container"
            className={classes.subheaderClass}
            style={{ color: PXBColors.white[400] }}
        >
            <BusinessIcon></BusinessIcon>
            <Box sx = {{ '& .MuiSvgIcon-root' : { color: 'white' } , '& .MuiOutlinedInput-root': {
                        '&': { border: '0px !important' }
                    }}}>
            <FormControl className={classes.formControl} >
                <Select
                    labelId="organization-dd-control-label"
                    id="organization-dd-control"
                    data-testid="organization-dd-control"
                    open={isDropdownOpen}
                    onClose={onDropdownCloseHandler}
                    onOpen={onDropdownOpenHandler}
                    value={selectedOrganization}
                    onChange={onSelectedOrganizationChangeHandler}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        MenuListProps: {
                            disablePadding: true,
                        },
                        PaperProps: {
                            style: { width: DRAWER_WIDTH },
                        },
                        classes: { paper: classes.PaperStyle },
                    }}
                    classes={{
                        icon: classes.icon,
                        select: classes.select,
                    }}
                    className={classes.dropdown}
                >
                    {organizationList.organizationList &&
                        organizationList.organizationList.map((item) => (
                            <StyledMenuItem
                                data-testid="organization-dropdown-item"
                                key={item.id}
                                value={item.id}
                                style={{ height: MENU_ITEM_HEIGHT }}
                            >
                                {item.name}
                            </StyledMenuItem>
                        ))}
                </Select>
            </FormControl>
            </Box>
        </div>
    );
};
